import React, { ReactNode } from 'react';
import {
    TextField,
    BooleanField,
    ChipField,
    EditButton,
    ShowButton,
    Filter,
    TextInput,
    SelectInput,
    ReferenceInput,
} from 'react-admin';
import CustomizableGrid from '../components/CustomizableGrid';
import { ColumnConfig } from '../hooks/useColumnReorder';

import CountryField from '../components/CountryField';
import CustomSearchInput from '../components/CustomSearchInput';
const TeamFilter = props => (
    <Filter variant="outlined" {...props}>
        <CustomSearchInput alwaysOn />
        <ReferenceInput
            source="countryId"
            reference="country"
            resource="country"
            label="Country"
        >
            <SelectInput optionText={choice => `${choice.name}`} />
        </ReferenceInput>
    </Filter>
);

const TeamList = ({ permissions = [], ...props }) => {
    // Define default columns configuration
    const defaultColumns: ColumnConfig[] = [
        { id: 'serial', label: 'Serial', visible: true, order: 0 },
        { id: 'id', label: 'ID', visible: true, order: 1 },
        { id: 'name', label: 'Name', visible: true, order: 2 },
        { id: 'active', label: 'Active', visible: true, order: 3 },
        { id: 'country', label: 'Country', visible: true, order: 4 },
        { id: 'edit', label: 'Edit', visible: true, order: 5 },
        { id: 'show', label: 'Show', visible: true, order: 6 },
    ];

    // Function to render column based on column ID
    const renderColumn = (columnId: string): ReactNode => {
        switch (columnId) {
            case 'serial':
                return (
                    <TextField
                        key={columnId}
                        source="serial"
                        sortable={false}
                    />
                );
            case 'id':
                return <TextField key={columnId} source="id" />;
            case 'name':
                return <TextField key={columnId} source="name" />;
            case 'active':
                return <BooleanField key={columnId} source="active" />;
            case 'country':
                return <CountryField key={columnId} />;
            case 'edit':
                return (
                    <EditButton
                        key={columnId}
                        color="secondary"
                        style={{ padding: 0 }}
                    />
                );
            case 'show':
                return <ShowButton key={columnId} style={{ padding: 0 }} />;
            default:
                return null;
        }
    };

    // Ensure we have all required props, but avoid duplicates with what might be in props
    const combinedProps = {
        title: 'Teams',
        permissions,
        defaultColumns,
        storageKey: 'teamListColumns',
        renderColumn,
        bulkActionButtons: false,
        filtersComponent: <TeamFilter />,
        sort: { field: 'id', order: 'ASC' },
        ...props,
        // Ensure these are set if not in props
        resource: props.resource || 'teams',
        location: props.location || { search: '' },
        hasShow: props.hasShow !== undefined ? props.hasShow : true,
    };

    return <CustomizableGrid {...combinedProps} />;
};

TeamList.defaultProps = {
    resource: 'teams',
    location: { search: '' },
};

export default TeamList;
